<template>
    <transition name="vip-popup-fade">
        <div v-if="isPopupVisible" id="vip_popup" @click.self="close">
            <div class="vip_popup" @click.stop>
                <!-- 支付界面 -->
                <div v-if="!vipStatus">
                    <div class="top">
                        <div class="tabList">
                            <div class="item" 
                            v-for="(item, index) in tabList"
                            :key="index"
                            :class="labelIndex === index ? 'active' : ''"
                            @click="handleChange(index)">
                                <img :src="item.icon" :class="'vip'+index" />
                                {{ item.name}}</div>
                        </div>
                        <!-- <img src="@/assets/image/icon_create3.png" class="top-close cursor_1" @click.self="close"/> -->
                          <svg-icon iconClass="del" class="custom top-close cursor_1 t-m-r-5" @click.self="close"/>
                    </div>
                    <main class="vip-main t-m-t-20" v-if="labelIndex === 0">
                        <vipCharge :plans="pricingOptions" :initial-active-index="selectedPlan"
                            @plan-selected="handlePlanSelected" >
                        </vipCharge>
                    </main>
                    <main class="vip-main t-m-t-36" v-else-if="labelIndex === 1">
                        <reduceCharge :plans="reduceOptions" :initial-active-index="selectedPlan"
                            @plan-selected="handlePlanSelected" >
                        </reduceCharge>
                    </main>
                    <div class="pay t-m-t-23">
                        <div class="pay-tips" v-if="labelIndex === 0">
                            <div class="vip-tip-container">
                                <div v-for="(segment, index) in tipSegments" :key="index" class="tip-item">
                                <!-- 纯文本段落 -->
                                <span v-if="segment.type === 'text'">{{ segment.content }}</span>
                                <!-- 混合段落（包含协议链接） -->
                                <template v-else-if="segment.type === 'mixed'">
                                    <span v-for="(part, pIndex) in segment.parts" :key="pIndex">
                                    <AgreementLink 
                                        v-if="part.isLink" 
                                        :text="part.text" 
                                        :type="part.type"
                                        @click-agreement="handleAgreementClick"
                                    />
                                    <span v-else>{{ part.text }}</span>
                                    </span>
                                </template>
                                
                                </div>
                            </div>
                            <!-- <p class="" v-for="(item,index) in vipTip" :key="index"> {{ item }}</p> -->
                        </div>
                        <div class="pay-tips" v-else>
                             <NoticeHighlight :content="rawDesc" />
                        </div>
                        <div class="pay-type">
                            <vipPrice  :vipItem="vipItem"  :labelIndex="labelIndex" :userVipType="userInfo.vipType"></vipPrice>
                        </div>
                    </div>
                </div>
                <!-- 权益对比的界面 -->
                <div v-else>

                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import data from '@/assets/data';
import vipCharge from './dongeb/vipCharge.vue';//收费选项模式
import reduceCharge from './dongeb/reduceCharge.vue';
import NoticeHighlight from './dongeb/NoticeHighlight.vue';
// import vipQuanyi from '../components/vip_quanyi.vue' //vip权益
import vipPrice from '../components/vip_price.vue' //vip支付
import { EventBus } from '@/utils/eventBus';
import AgreementLink from './AgreementLink.vue';
import api from '@/api/api';
export default {

    components: {
        // vipQuanyi,
        vipPrice,
        reduceCharge,
        AgreementLink,
        NoticeHighlight,
        vipCharge
    },
    data() {
        return {
            tabList:[{name:"会员中心",icon:require("@/assets/image/vip/vip_tab01.png")},{name:"降痕字符包",icon:require("@/assets/image/vip/vip_tab02.png")}],
           labelIndex:0,
            headImg: data.headImg, //用户头像 vip
            qunayiList: [], //权益对比
            isPopupVisible: false,
            vipStatus: 0, // 0会员 1会员权益
            userInfo: {}, //用户信息
            loginState: false, //登录状态
            vipTip: data.vipTip,
            reduceVipTip:"",
            tipSegments:[],
            rawDesc:'',
            parsedSections:[],
            selectedPlan: 0, // 默认选中第三个
            vipItem:{},//选择的套餐
            pricingOptions: [],
            reduceOptions:[],//消痕套餐列表
        };
    },
     watch: {
        reduceVipTip() {
            this.parseTips();
        }
    },
    mounted() {
        EventBus.$on('openVip', (labelIndex = 0) => {
            this.labelIndex = labelIndex;
            this.isPopupVisible = true;
            this.vipStatus = 0
            this.getUserinfo()
            this.getRights()
            this.getVipList()
            this.getReducelist()
            this.getReduceNoticeBuy()
            this.getMemberNoticeBuy()
        })
    },
    beforeDestroy() {
        EventBus.$off('openVip');
    },
    methods: {
        //获取ai消痕套餐列表
        getReducelist(){
            api.getReducelist().then((res)=>{
                if(res.code === 200){
                    this.reduceOptions = res.data
                    //this.parseDescription();
                }
            })
        },
        //会员须知
        getMemberNoticeBuy(){
             api.getMemberNoticeBuy().then((res)=>{
                if(res.code === 200){
                    this.reduceVipTip = res.data
                   // this.parseTips()
                }
            })
        },
        //消痕购买须知
        getReduceNoticeBuy(){
           api.getReduceNoticeBuy().then((res)=>{
                if(res.code === 200){
                    this.rawDesc = res.data
                   // this.parseTips()
                }
            })
        },
        parseTips() {
        if (!this.reduceVipTip) return;
        const lines = this.reduceVipTip.split('\n');
        const agreements = ['《用户协议》', '《会员协议》', '《消费者权益保护法》'];
        
        this.tipSegments = lines.map(line => {
            if (!line) return { type: 'text', content: '' };
            
            // 检查该行是否包含协议
            let foundAgreement = null;
            for (let agg of agreements) {
            if (line.includes(agg)) {
                foundAgreement = agg;
                break;
            }
            }

            if (foundAgreement) {
            // 如果一行中有多个协议或复杂情况，建议用正则分割
            // 这里简化处理：假设一行主要突出一个协议，或者将整行作为文本，协议部分单独提取
            // 更健壮的做法是使用 split 保留分隔符
            const parts = line.split(new RegExp(`(${agreements.join('|')})`, 'g'));
            
            return {
                type: 'mixed',
                parts: parts.map(part => {
                if (agreements.includes(part)) {
                    return { isLink: true, text: part, type: part };
                } else {
                    return { isLink: false, text: part };
                }
                })
            };
            } else {
            return { type: 'text', content: line };
            }
        });
        },
        getVipList() {
            api.getViplist({ version: '1' }).then((res) => {
                if (res.code == 200 && res.data && res.data.length > 0) {
                    let viplist = res.data
                    api.getRight().then((result) => {
                        if (result.code == 200) {
                            let qylist = result.data
                            this.pricingOptions = viplist.map(item => {
                                for (let i in qylist) {
                                    let qyitem = qylist[i]
                                    if (!item.tag) {
                                        // if (['month','year','half_year'].includes(item.type) && (qyitem.type.includes('month_year'))) {
                                        //     if (item.timing) {
                                        //         item.rightImg = require('@/assets/image/vip/icon2.png')
                                        //         item.countdown = true
                                        //     }
                                        //     //2025年8月4号 要求隐藏线上会员套餐step里的内容（支持pc端，双端同步，地址：http://novel.esrke.com）
                                        //     // item.steps = qyitem.right ? qyitem.right.filter((item,i)=> i!=2) : ''
                                        //     item.steps = qyitem.right 
                                        //     // console.log('item.steps=',item.steps)
                                        // }
                                        // else if(!['month','year','half_year'].includes(item.type) && (qyitem.type.includes('month_year'))) {
                                        //     if (item.timing) {
                                        //         item.rightImg = require('@/assets/image/vip/icon2.png')
                                        //         item.countdown = true
                                        //     }
                                        //     item.steps = qyitem.right
                                        // }
                                        if(item.type === qyitem.type){
                                            if(item.timing){
                                                item.rightImg = require('@/assets/image/vip/icon2.png')
                                                item.countdown = true
                                            }
                                            item.steps = qyitem.right
                                        }else if(item.type !== qyitem.type && (qyitem.type.includes('month_year'))){
                                             if (item.timing) {
                                                item.rightImg = require('@/assets/image/vip/icon2.png')
                                                item.countdown = true
                                            }
                                            item.steps = qyitem.right
                                        }

                                    } else {
                                        if(item.type === qyitem.type){
                                            item.steps = qyitem.right
                                        }else if(item.type !== qyitem.type && (qyitem.type.includes('month_year'))){
                                            item.steps = qyitem.right
                                        }
                                        // //永久
                                        // if (['perpetual','year_ensure','year_coach'].includes(item.type) && qyitem.type === 'year_coach') {
                                        //     // item.rightImg = require('@/assets/image/vip/icon5.png')
                                        //     item.steps = qyitem.right
                                        // }
                                        // // 季度和半年
                                        // else if (['three_months','half_year'].includes(item.type) && qyitem.type === 'month_year') {
                                        //     // item.rightImg = require('@/assets/image/vip/icon4.png')
                                        //     item.steps = qyitem.right
                                        // }
                                        // else if (item.type === 'year_ensure' && qyitem.type === 'year_ensure') {
                                        //     // item.rightImg = require('@/assets/image/vip/icon4.png')
                                        //     item.steps = qyitem.right
                                        // }
                                    }
                                }
                                return item
                            })
                            console.log('pricingOptions=', this.pricingOptions)
                            //初始化默认套餐选项
                            this.handlePlanSelected(this.selectedPlan)
                        }
                    })
                }
            })
        },
        handleChange(index) {
			if (this.labelIndex === index) return
			this.labelIndex = index
             this.handlePlanSelected(this.selectedPlan)
		},
        handleAgreementClick(type){
             let targetUrl = ''
            if(type==="《用户协议》"){
                console.log(1)
                 targetUrl = 'https://api.esrke.com/rest/novel/public/protocol?type=yhxy&platform=pc'
            }else if(type === "《会员协议》"){
                targetUrl = 'https://api.esrke.com/rest/novel/public/protocol?type=hyxy&platform=pc'
            }
            if(targetUrl) {
                // 新窗口打开协议页面
                window.open(targetUrl, '_blank')
            }
        },
        //选择套餐
        handlePlanSelected(index) {
            // if(this.selectedPlan === index) return
            this.selectedPlan = index
            if(this.labelIndex === 0){
                 this.vipItem = this.pricingOptions[this.selectedPlan]
            }else{
                this.vipItem = this.reduceOptions[this.selectedPlan]
            }
            console.log('选中了套餐:', this.pricingOptions[index])
        },
        //获取用户信息
        getUserinfo() {
            api.getUserinfo().then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.userInfo = res.data
                    this.loginState = true
                }
            })
        },
        //权益对比
        getRights() {
            api.getRights().then((res) => {
                if (res.code == 200) {
                    this.qunayiList = res.data
                }
            })
        },
        toLogin() {
            if (!this.loginState) {
                EventBus.$emit('openLogin')
                this.close()
            }
        },
        close() {
            this.isPopupVisible = false;
        },
        switchI(i) {
            this.vipStatus = i
        }
    }
}
</script>

<style lang="scss" scoped>
p {
    margin: 0;
    padding: 0;
}

#vip_popup {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.vip_popup {
    width: 1245px;
    height: 830px;
    background: #FFFFFF;
    border-radius: 20px;
}

.top {
    width: 1245px;
    // background: url('@/assets/image/vip/top_bg.png') no-repeat;
    background-size: cover;
    position: relative;
    .tabList{
        background-color: #0E0D1B;
        border-radius: 20px;
        margin: 20px 50px 0;
        display: flex;
        height: 79px;
        align-items: center;
        color: #fff;
        font-size: 36px;
        .item{
             width: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .vip0{
                margin-right: 20px;
            }
            .vip1{
                margin-top: 10px;
            }
        }
        .active{
            height: 73px;
            border-radius: 18px;
            font-weight: bold;
            margin: 3px;
            background-image: linear-gradient(to right, #FE8E35, #F72C28);
        }
    }
    .top-close{
        position: absolute;
        right:10px;
        top: 20px;
    }
}

.vip-main {
    width: 100%;
}
.vip-tip-container{
    .tip-item{
        font-size: 13px;
        line-height: 1.6;
    }
}
.pay {
    padding-left: 64px;
    padding-right: 37px;
    display: flex;
    align-items: center;

    .pay-tips {
        width: 620px;
        height: 160px;
        background-color: rgba(212,121,43,.2);
        // background: url("../assets/image/vip/vip_bg01.png") no-repeat;
        background-size: 100% 100%;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left:20px;
        padding-right: 20px;
        p {
            position: relative;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #71524A;

            &::before {
                content: '';
                position: absolute;
                width: 6px;
                height: 6px;
                background-color: #D4792B;
                border-radius: 50%;
                top: 7px;
                left: -10px;
            }
        }
    }
}
.custom{
    color: #FF6603;
    font-size: 24px;
}
</style>